import { Link } from "react-router-dom";
import type { Comic } from "@/mocks/comics";

interface Props {
  comic: Comic;
  rank?: number;
}

export default function ComicCard({ comic, rank }: Props) {
  return (
    <article className="group relative flex flex-col overflow-hidden rounded-xl bg-background-50 ring-1 ring-background-200/70 transition-all duration-300 hover:-translate-y-1 hover:ring-primary-300">
      <Link
        to={`/detail/${comic.id}`}
        className="relative block aspect-[5/7] w-full overflow-hidden"
        aria-label={`阅读《${comic.title}》`}
      >
        <img
          src={comic.cover}
          alt={`${comic.title} 封面，${comic.category}题材韩国漫画`}
          title={`${comic.title} · ${comic.category}漫画`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-x-0 top-0 flex items-center justify-between p-2">
          {rank !== undefined ? (
            <span className="flex h-6 min-w-6 items-center justify-center rounded-md bg-primary-500 px-1.5 font-display text-xs font-bold text-background-50">
              {rank}
            </span>
          ) : (
            <span className="rounded-md bg-background-950/55 px-2 py-0.5 text-[11px] font-medium text-background-50 backdrop-blur">
              {comic.category}
            </span>
          )}
          {comic.status === "连载中" && (
            <span className="rounded-md bg-accent-500 px-2 py-0.5 text-[11px] font-medium text-background-50">
              连载中
            </span>
          )}
        </div>
        <div className="absolute inset-x-0 bottom-0 flex items-center justify-between bg-gradient-to-t from-background-950/70 to-transparent px-2 pb-2 pt-6 text-[11px] font-medium text-background-50">
          <span className="flex items-center gap-1">
            <i className="ri-eye-line" aria-hidden="true"></i>
            {comic.views}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-star-fill text-accent-400" aria-hidden="true"></i>
            {comic.rating.toFixed(1)}
          </span>
        </div>
      </Link>

      <div className="flex flex-1 flex-col p-3">
        <Link
          to={`/detail/${comic.id}`}
          className="truncate font-display text-sm font-bold text-foreground-950 transition-colors group-hover:text-primary-600"
          title={comic.title}
        >
          {comic.title}
        </Link>
        <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-foreground-600">{comic.intro}</p>
        <div className="mt-auto flex flex-wrap items-center gap-1 pt-2.5">
          {comic.tags.slice(0, 2).map((tag) => (
            <span
              key={tag}
              className="rounded-md bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900"
            >
              #{tag}
            </span>
          ))}
          <span className="ml-auto text-[11px] text-foreground-400">{comic.chapters}话</span>
        </div>
      </div>
    </article>
  );
}